import { useEffect, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from './config';
import { setPageMeta } from '../../lib/seo';

export function LegalPage({ title, children }: { title: string; children: ReactNode }) {
  useEffect(() => {
    setPageMeta(`${title} · SuperFunUBG`, `${title} for SuperFunUBG, a free unblocked games site run by Stuffly LLC.`, location.pathname);
    window.scrollTo(0, 0);
  }, [title]);
  return (
    <main id="main" className="legal">
      <div className="band band--hero legal__hero">
        <div>
          <h1 className="hero__title">{title}</h1>
          <p className="legal__date">Effective {LEGAL.effectiveDate}</p>
        </div>
      </div>
      <article className="legal__body">{children}</article>
      <nav className="legal__nav" aria-label="Legal">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/">All games</Link>
      </nav>
    </main>
  );
}

export function Contact() {
  return LEGAL.contactEmail ? <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a> : <span>(contact address not yet provided)</span>;
}
